import { Logger } from '@vp/ubik-logging'
import { applyServiceHeaders } from 'server/utils/applyServiceHeaders'
import { createApiClient } from 'shared/services/ApiClient'
import { ApiClient } from 'shared/services/ApiClient/interface'
import type { GalleryConfigIServiceConfig } from 'shared/types/gallery/config'
import type { GalleryLoggerILogger } from '~/app/features/Gallery/interface'

export type LoggerParameter = (() => GalleryLoggerILogger) | GalleryLoggerILogger

export class AbstractService {
  api: ApiClient

  config: GalleryConfigIServiceConfig

  loggerOrProvider: LoggerParameter

  constructor(serviceConfig: GalleryConfigIServiceConfig, logger: LoggerParameter) {
    this.api = createApiClient(
      {
        ...applyServiceHeaders({
          ...serviceConfig,
        }),
      },
      this.constructor.name,
    )

    this.config = serviceConfig || {}
    this.loggerOrProvider = logger
  }

  get logger(): Logger {
    return typeof this.loggerOrProvider === 'function' ? this.loggerOrProvider() : this.loggerOrProvider
  }
}
